import throttle from 'lodash/throttle';
import { useEffect, useMemo, useState } from 'react';
import theme, { Screen as ScreenSize } from '../theme';

const getDeviceConfig = (width: number): ScreenSize => {
  const xs = parseInt(theme.screen.xs, 10);
  const sm = parseInt(theme.screen.sm, 10);
  const md = parseInt(theme.screen.md, 10);
  const lg = parseInt(theme.screen.lg, 10);
  const xl = parseInt(theme.screen.xl, 10);

  if (width < xs) {
    return 'xs';
  } else if (width >= xs && width < sm) {
    return 'sm';
  } else if (width >= sm && width < md) {
    return 'md';
  } else if (width >= md && width < lg) {
    return 'lg';
  } else if (width >= lg && width < xl) {
    return 'xl';
  } else if (width >= xl) {
    return 'xxl';
  }
  return 'xxl';
};

const useBreakpoints = () => {
  const [breakPoint, setBreakPoint] = useState<ScreenSize>(() => getDeviceConfig(window.innerWidth));

  useEffect(() => {
    const calcInnerWidth = throttle(function () {
      setBreakPoint(getDeviceConfig(window.innerWidth));
    }, 200);

    window.addEventListener('resize', calcInnerWidth);

    return () => window.removeEventListener('resize', calcInnerWidth);
  }, []);

  const isMobileScreen = useMemo(() => breakPoint === 'xs' || breakPoint === 'sm', [breakPoint]);
  const isSmallScreen = useMemo(() => isMobileScreen || breakPoint === 'md', [breakPoint, isMobileScreen]);
  const isLargeScreen = useMemo(() => isSmallScreen || breakPoint === 'lg', [breakPoint, isSmallScreen]);
  const isXLargeScreen = useMemo(() => isLargeScreen || breakPoint === 'xl', [breakPoint, isLargeScreen]);

  return { breakPoint, isSmallScreen, isMobileScreen, isLargeScreen, isXLargeScreen };
};

export default useBreakpoints;
